const Footer = () => {
  return (
    <div className='footer'>
      <span>Source code can be found&nbsp;</span>
      <a href='https://github.com/okkokuisma/birdnest'>here.</a>
    </div>
  );
};

export default Footer;